import * as React from 'react'
import { Icons } from '@lacedltd/laced-components'
import { withTranslations } from 'helpers'
import * as S from './Search.styles'

const AlgoliaSearch = React.lazy(() => import('./AlgoliaSearch'))

const Search = ({ userId }: { userId?: string }) => {
  const [showSearchInput, setShowSearchInput] = React.useState(false)

  return (
    <>
      <S.SearchBarContainer>
        <S.SearchIconWrapper
          data-testid="instantsearch-button"
          aria-label="search laced products"
          tabIndex={0}
          onClick={() => {
            setShowSearchInput((prev) => !prev)
          }}
          showSearchInput={showSearchInput}
        >
          <Icons.Search />
        </S.SearchIconWrapper>
      </S.SearchBarContainer>
      {showSearchInput ? (
        <React.Suspense
          fallback={
            <S.NavbarBackdrop>
              <S.LoadingContainer>
                <Icons.LoadingCircle />
              </S.LoadingContainer>
            </S.NavbarBackdrop>
          }
        >
          <AlgoliaSearch
            userId={userId}
            onClose={() => setShowSearchInput(false)}
          />
        </React.Suspense>
      ) : null}
    </>
  )
}

export default withTranslations(Search)
